import React from 'react';
import './footer.css'

const Footer = () => {
    return (
        <div>
        <footer id="footer">
        <div class="footer-top">
          <div class="container">
            <div class="row">
    
              <div class="col-lg-4 col-md-6">
                <div class="footer-info">
                  <h3>Simple Contract</h3>
                  <p class="pb-3"><em>Complete Legal Contract and document Analysis</em></p>
                  <p>
                    
                    
                  </p>
                  
                </div>
              </div>
    
             
              
    
              
            </div>
          </div>
        </div>
    
        <div class="container">
          <div class="copyright">
            &copy; Copyright <strong><span>Simple Contract</span></strong>. All Rights Reserved
          </div>
          
        </div>
      </footer>
            
        </div>
    )
}


export default Footer;